var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var ScrollListener = /** @class */ (function (_super) {
    __extends(ScrollListener, _super);
    function ScrollListener() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { top: 0, activeId: undefined };
        _this.top = 0;
        _this.scheduledAnimationFrame = false;
        _this.scroll = function () {
            _this.top = window.scrollY;
            if (_this.scheduledAnimationFrame) {
                return;
            }
            _this.scheduledAnimationFrame = true;
            requestAnimationFrame(_this.handler);
        };
        _this.handler = function () {
            var currLink = null;
            for (var i = 0; i < _this.links.length; i++) {
                var link = _this.links[i];
                var linkTop = link.getBoundingClientRect().top;
                if (linkTop <= 1) {
                    currLink = link;
                }
                else {
                    break;
                }
                /* if (
                  refElement.position().top <= scrollPos &&
                  refElement.position().top + refElement.height() > scrollPos
                ) {
                  $('a').removeClass('active');
                  currLink.addClass('active');
                } else {
                  currLink.removeClass('active');
                } */
            }
            _this.setState({ top: _this.top, activeId: currLink && currLink.id });
            _this.scheduledAnimationFrame = false;
        };
        return _this;
    }
    ScrollListener.prototype.componentDidMount = function () {
        document.addEventListener('scroll', this.scroll);
        this.links = document.querySelectorAll('[data-scroll-anchor]');
    };
    ScrollListener.prototype.componentWillUnmount = function () {
        document.removeEventListener('scroll', this.scroll);
    };
    ScrollListener.prototype.render = function () {
        var render = this.props.render;
        var _a = this.state, top = _a.top, activeId = _a.activeId;
        return render(top, activeId);
    };
    return ScrollListener;
}(React.Component));
export default ScrollListener;
//# sourceMappingURL=index.js.map